import React from 'react'
import classes from './TempLink.module.scss';
import { useTranslation } from 'react-i18next';

export default function ErrorPage({error}: {error: string}) {
  const { t } = useTranslation();
  // console.log(error, 'getted error');
  
  return (
    <div className={classes.errorWrap}>
      <div>{t('templink.documentError')}.</div>
      <div>{t('templink.documentMissing')}.</div>
    </div>
  )
}
